// ⚠️ Make sure to keep this up to date with the backend email Regex
// You can find the backend version at: apps/infrastructure/validators/email_format_validator.rb
export const EMAIL_REGEX = new RegExp("^([\\w.%+-]+)@([a-zA-Z0-9-]+\\.)+([a-zA-Z0-9]{2,})$");
